import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "offline-payment-detail",
  components: {},
  props: ["data"],
  mixins: [$thousandMask],
  filters: {
    formatDate(date) {
      let format =
        localStorage.getItem("lang") === "fa"
          ? "YYYY/MM/DD - HH:mm"
          : "YYYY/DD/MM - HH:mm";

      return dayjs(parseInt(date)).format(format);
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
